import { Component, OnInit, ViewChild, EventEmitter, Output } from "@angular/core";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormControl, FormGroup } from "@angular/forms";
import { ImageAppService } from '../../../../service/api/builk/image-app.service';
import { UpdateStatusImageAppModel } from "../../../../model/builk/image-app/update-status-image-app.mpde";
import { LocalStorageService } from "angular-2-local-storage";

@Component({
  selector: 'app-image-app-confirm-update-status',
  templateUrl: './image-app-confirm-update-status.component.html',
  styleUrls: ['./image-app-confirm-update-status.component.css']
})
export class ImageAppConfirmUpdateStatusComponent implements OnInit {


  private ngbModalRef: NgbModalRef;
  imageAppSurrKey: number;
  active: boolean;
  model: UpdateStatusImageAppModel = new UpdateStatusImageAppModel();
  countDay: FormControl = new FormControl();
  formGroup: FormGroup = new FormGroup({
    countDay: this.countDay
  });
  center: any;
  constructor(
    private modalService: NgbModal,
    private readonly imageAppService: ImageAppService ,
    private localStorageService: LocalStorageService
    ) {

  }
  @ViewChild("content") content: any;
  @Output() cancelEvent = new EventEmitter();

  @Output() okEvent = new EventEmitter();

  public ngOnInit(): void {

  }
  public openModal(imageAppSurrKey: number, active: boolean): void {
    this.imageAppSurrKey = imageAppSurrKey;
    this.active = active;
    this.ngbModalRef = this.modalService.open(this.content, { centered: true, size: 'lg' });
  }

  public hide(): void {
    this.ngbModalRef.close();
  }

  ok(): void {
    this.model.imageAppSurrKey = this.imageAppSurrKey;
    this.model.status = this.active;
    this.model.userEmail = this.localStorageService.get("userEmail");
    
    this.imageAppService.updateStatusImageApp(this.model).subscribe(res => {
      this.okEvent.emit(true);
      this.hide();
    }, (err) => {

    });
  }

  cancel(): void {
    this.cancelEvent.emit();
    this.hide();
  }
}
